import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './NotFound.css';

function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="notfound-container">
      <div className="notfound-content">
        {/* 404 Icon */}
        <div className="notfound-icon">
          <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
            <circle cx="60" cy="60" r="50" stroke="#3B82F6" strokeWidth="4" strokeLinecap="round" strokeDasharray="8 8"/>
            <path d="M45 75L60 60L75 75M60 60V90" stroke="#3B82F6" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="45" cy="45" r="3" fill="#3B82F6"/>
            <circle cx="75" cy="45" r="3" fill="#3B82F6"/>
          </svg>
        </div>

        {/* Error Code */}
        <h1 className="notfound-code">404</h1>

        {/* Error Message */}
        <h2 className="notfound-title">페이지를 찾을 수 없습니다</h2>
        <p className="notfound-message">
          요청하신 페이지가 존재하지 않거나 이동되었습니다.
        </p>

        {/* Current Path */}
        <div className="notfound-path">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M7.33333 2.66667L2.66667 6.66667V12.6667C2.66667 13.0203 2.80714 13.3594 3.05719 13.6095C3.30724 13.8595 3.64638 14 4 14H6.66667V10C6.66667 9.64638 6.80714 9.30724 7.05719 9.05719C7.30724 8.80714 7.64638 8.66667 8 8.66667C8.35362 8.66667 8.69276 8.80714 8.94281 9.05719C9.19286 9.30724 9.33333 9.64638 9.33333 10V14H12C12.3536 14 12.6928 13.8595 12.9428 13.6095C13.1929 13.3594 13.3333 13.0203 13.3333 12.6667V6.66667L8.66667 2.66667C8.48256 2.51158 8.24624 2.42569 8.00001 2.42569C7.75377 2.42569 7.51745 2.51158 7.33333 2.66667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span className="notfound-path-text">{location.pathname}</span>
        </div>

        {/* Action Buttons */}
        <div className="notfound-actions">
          <button className="notfound-btn btn-secondary" onClick={handleGoBack}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            이전 페이지
          </button>
          <button className="notfound-btn btn-primary" onClick={handleGoHome}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M2 6L8 2L14 6V13C14 13.2652 13.8946 13.5196 13.7071 13.7071C13.5196 13.8946 13.2652 14 13 14H3C2.73478 14 2.48043 13.8946 2.29289 13.7071C2.10536 13.5196 2 13.2652 2 13V6Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M6 14V8H10V14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            홈으로
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
